import { Box, Divider, IconButton, Tab, TabContext, TabList, TabPanel } from "@platform/style";
import * as React from "react";
import { InactiveWorkItemGrid } from "./InactiveWorkItemGrid";
import { ActiveWorkItemGrid } from "./ActiveWorkItemGrid";
import { Metrics } from "../../models/Metrics";
import { hasPermission, isFeatureEnabled } from "@platform/core";
import { MetricsCards } from "../MetricsCards";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/sharp-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faCalendarDays);
const metricsInitialization: Metrics = {
  totalWorkCount: 0,
  assignedCount: 0,
  unAssignedCount: 0,
  targetPastDueDateCount: 0,
  dueTodayCount: 0,
  completedCount: 0,
  cancelledCount: 0,
};
export const WorkItemTabs = () => {
  const [value, setValue] = React.useState("Active");
  const [metrics, setMetrics] = React.useState<Metrics>(metricsInitialization);
  const [metricsAccess, setMetricsAccess] = React.useState<boolean>(false);
  const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
  const [showInactiveDefaultMessage, setShowInactiveDefaultMessage] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    (async () => {
      setMetricsAccess(
        (await hasPermission("WorkManagementAdmin.viewMetrics")) &&
          (await isFeatureEnabled("WorkItems.Metrics"))
      );
    })();
  }, []);

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box
      height={"100%"}
      width={"100%"}
      display={"grid"}
      gridTemplateRows={"min-content min-content min-content minmax(0, 1fr)"}
      overflow={"hidden"}
    >
      {value == "Inactive" && showInactiveDefaultMessage ? (
        <Box
          aria-label="inactive-default-message"
          sx={{
            p: 2,
            border: "1px solid silver",
            color: "primary.main",
            fontFamily: "suisse",
            fontSize: "small",
            width: "100%",
            backgroundColor: "#eeeeee",
            height: "14px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconButton
            size={"small"}
            aria-label={"Mark work as cancelled"}
            sx={{ padding: 1, ml: 2 }}
          >
            <FontAwesomeIcon icon={faCalendarDays} />
          </IconButton>
          Showing inactive work over the last 14 days by default. Filters can be cleared or modified
          using the options in the toolbar.
        </Box>
      ) : (
        <Box />
      )}

      {metricsAccess && (
        <MetricsCards typeOfWorkItemPage={value} metrics={metrics} isLoaded={isLoaded} />
      )}

      <TabContext value={value}>
        <Box sx={{ width: "50%" }}>
          <TabList
            onChange={handleChange}
            sx={{
              "& .MuiTabs-indicator": {
                height: "4px",
              },
            }}
          >
            <Tab label="Active Work" value="Active" />
            <Tab label="Inactive Work" value="Inactive" />
          </TabList>
        </Box>
        <Box>
          <TabPanel sx={{ height: "100%", width: "100%", padding: "0px" }} value={value}>
            <Divider sx={{ borderBottomWidth: 2, borderColor: "divider" }} />
            {value == "Active" ? (
              <ActiveWorkItemGrid setMetrics={setMetrics} setIsLoaded={setIsLoaded} />
            ) : (
              <InactiveWorkItemGrid
                setMetrics={setMetrics}
                setIsLoaded={setIsLoaded}
                setShowInactiveDefaultMessage={setShowInactiveDefaultMessage}
              />
            )}
          </TabPanel>
        </Box>
      </TabContext>
    </Box>
  );
};
